import { useLayoutEffect, useRef, useState } from 'react'
import { PickerSheet } from './DatePicker'

// Собственный пикер времени вместо <input type="time">: нативное поле на iOS
// навязывает свою минимальную ширину. Здесь поле — обычная строка формы на 100%
// ширины, а выбор — два прокручиваемых столбца (часы / минуты) во вложенном листе.

const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'))
const MINUTES = Array.from({ length: 12 }, (_, i) => String(i * 5).padStart(2, '0'))

/** Столбец значений с прокруткой; выбранное подсвечено и центрируется при открытии. */
function Column({ values, selected, onSelect }: {
  values: string[]
  selected: string
  onSelect: (v: string) => void
}) {
  const ref = useRef<HTMLDivElement>(null)

  // Центрируем выбранное значение, меняя scrollTop напрямую — не трогаем другие
  // скролл-контейнеры (в отличие от scrollIntoView).
  useLayoutEffect(() => {
    const el = ref.current
    const sel = el?.querySelector<HTMLElement>('[data-sel="1"]')
    if (el && sel) el.scrollTop = sel.offsetTop - el.clientHeight / 2 + sel.clientHeight / 2
  }, [])

  return (
    <div ref={ref} className="flex-1 min-w-0 overflow-y-auto" style={{ maxHeight: 240 }}>
      {values.map(v => (
        <button
          type="button"
          key={v}
          data-sel={v === selected ? '1' : undefined}
          onClick={() => onSelect(v)}
          className={`w-full py-2.5 rounded-lg text-center tabular-nums text-base ${
            v === selected ? 'bg-accent-dim text-accent font-medium' : 'text-ink'
          }`}
        >
          {v}
        </button>
      ))}
    </div>
  )
}

interface TimePickerProps {
  value: string
  onChange: (value: string) => void
  /** z-index листа: должен быть выше формы (70) и тоста (80). */
  zIndex?: number
}

export function TimePicker({ value, onChange, zIndex = 90 }: TimePickerProps) {
  const [open, setOpen] = useState(false)
  const [hh, mm] = (value || '09:00').split(':')

  return (
    <>
      <button
        type="button"
        className="form-input text-left tabular-nums"
        onClick={() => setOpen(true)}
      >
        {value}
      </button>

      {open && (
        <PickerSheet onClose={() => setOpen(false)} zIndex={zIndex}>
          <div className="px-4 pb-4">
            <div className="flex gap-3 mb-1">
              <p className="form-label flex-1 text-center" style={{ marginBottom: 0 }}>Часы</p>
              <p className="form-label flex-1 text-center" style={{ marginBottom: 0 }}>Минуты</p>
            </div>
            <div className="flex gap-3">
              <Column values={HOURS} selected={hh} onSelect={v => onChange(`${v}:${mm}`)} />
              <Column values={MINUTES} selected={mm} onSelect={v => onChange(`${hh}:${v}`)} />
            </div>
            <button
              type="button"
              className="btn-primary w-full mt-3"
              onClick={() => setOpen(false)}
            >
              Готово
            </button>
          </div>
        </PickerSheet>
      )}
    </>
  )
}
